<div class="mx-auto max-w-8xl text-5xl">
  <form [formGroup]="newGroupForm" >
    <fieldset class="m-5 border-[3px] border-cliking_blue rounded-3xl relative">
      <legend class="text-sm px-5 py-1 rounded-3xl bg-cliking_blue text-white">
        Enter New Group Details
      </legend>
      <div class="join m-5 flex flex-wrap gap-2">
        <!-- Group Name -->
        <input
          class="input input-bordered input-sm"
          type="text"
          placeholder="Group name"
          formControlName="name"
          [ngClass]="{
            'input-error': newGroupForm.get('name')?.invalid && newGroupForm.get('name')?.touched,
            'input-accent': newGroupForm.get('name')?.valid
          }"
        />
        <!-- Group Url -->
        <label
          for=""
          class="text-sm mb-2 bg-cliking_blue_nuance text-white font-bold rounded-md px-2 pt-1 cursor-pointer"
          (click)="isGroupImageUrlOpen=true"
        >
          <i class="fa fa-paperclip" aria-hidden="true"></i>
        </label>
        <span
          *ngIf="selectedFile"
          class="px-2 text-xs border-cliking_red rounded-full text-cliking_red w-6 h-6 text-center cursor-pointer"
          (click)="selectedFile=null"
        >✕</span>

        <div
          *ngIf="isGroupImageUrlOpen"
          class="absolute w-[60%] m-auto top-[25%] z-40 bg-white border-2 border-cliking_blue_nuance rounded-3xl overflow-auto h-[70vh]"
        >
          <app-image-uploader
            [croppedImage]="selectedFile?.croppedImage"
            [imageChangedEvent]="selectedFile?.imageChangedEvent"
            [isVisible]="isGroupImageUrlOpen"
            (onPanelClosed)="isGroupImageUrlOpen = false"
            (onImageConfirmed)="setGroupURLImage($event)"
          />
        </div>

        <!-- client satisfactionID -->
        <input
          class="input input-bordered input-sm"
          type="text"
          placeholder="client satisfaction Id"
          formControlName="clientSatisfactionId"
          [ngClass]="{
            'input-error': newGroupForm.get('clientSatisfactionId')?.invalid && newGroupForm.get('clientSatisfactionId')?.touched,
            'input-accent': newGroupForm.get('clientSatisfactionId')?.valid
          }"
        />

        <button
          class="btn text-white bg-dark_blue btn-sm hover:bg-cliking_blue"
          [disabled]="isParentSkipped"
          onclick="my_modal_2.showModal()"
        >
          choose Parent
          <div
            *ngIf="selectedGroup?.name"
            class="badge badge-secondary"
            [ngClass]="{
              'bg-gray-400 border-none text-gray-300': isParentSkipped
            }"
          >
            {{ selectedGroup?.name }}
          </div>
        </button>
        <dialog id="my_modal_2" class="modal">
          <div class="modal-box">
            <app-tree-view
              (itemSelected)="updateSelectedParentGroup($event)"
              [data]="rootGroups?.data"
            />
          </div>
          <form method="dialog" class="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>

        <div class="form-control">
          <label class="cursor-pointer label">
            <span class="label-text inline-block w-max-[100%] overflow-ellipsis text-nowrap">is Top Level?</span>
            <input
              type="checkbox"
              class="checkbox checkbox-accent ml-3"
              [checked]="isParentSkipped"
              (change)="updateCheckbox()"
            />
          </label>
        </div>

        <div class="form-control">
          <label class="cursor-pointer label">
            <span class="label-text inline-block w-max-[100%] overflow-ellipsis text-nowrap">has Sagamm Logo ?</span>
            <input
              type="checkbox"
              class="checkbox checkbox-accent ml-3"
              [checked]="hasSagammLogo"
              (change)="updatePartnerCheckBox()"
            />
          </label>
        </div>

        <div class="form-control">
          <label class="cursor-pointer label">
            <span class="label-text inline-block w-max-[100%] overflow-ellipsis text-nowrap">is fake ?</span>
            <input
              type="checkbox"
              class="checkbox checkbox-accent ml-3"
              [checked]="isGroupFake"
              (change)="updateGroupFakeCheckBox()"
            />
          </label>
        </div>

        <button
          class="btn btn-circle btn-accent btn-sm text-white"
          (click)="createNewGroup()"
          [disabled]="!newGroupForm.valid || !isGroupParentValid()"
        >
          +
        </button>
      </div>
    </fieldset>
  </form>
  <p class="text-xs" > {{selectedFile|json}}</p>
  <app-table
    [res]="rootGroups"
    [isBrowsable]="true"
    [isWriteEnabled]="true"
    [selectedImage]="selectedFile"
    [skipColumns]="[
      'parent',
      'socialMedia',
      'ancestry',
      'expanded',
      'children',
      'depth',
    ]"
    [readOnlyKeys]="['children', 'Subgroups']"
    (UpdateGroups)="onUpdateGroups()"
    (editItem)="updateGroup($event)"
    (deleteItem)="deleteGroup($event)"
    (firstClicked)="getGroupsFirstPage()"
    (previoustClicked)="getGroupsPreviousPage()"
    (nextClicked)="getGroupsNextPage()"
    (lastClicked)="getGroupsLastPage()"
    [entity]="'Group'"
    [isAdmin]="true"
    (openfetchPostsModal)="showFetchPostsModal($event)"
    (onCroppedImageConfirmed)="setGroupURLImage($event)"
    (onCroppedImageCleared)="selectedFile=null"
  >
  </app-table>

  <app-modal
    [isOpen]="isFetchModalOpen"
    (closeModal)="closeFetchPostsModal()"
    [heading]="'fetch posts modal'"
    [showCloseBtn]="true"
    (closeModal)="isFetchModalOpen=false"
  >

  <span class="text-sm">
    <div>Fetching posts of group</div>
    <div class="join-vertical">
      <span class="font-bold">{{ currentGroup?.name }}  ({{ currentGroup?.socialMedia?.length }} total pages)</span>
    </div>
  </span>
  <span class="font-bold text-sm"><span  [ngClass]="{'text-cliking_green':activePages.length==0,'text-cliking_yellow':activePages.length==1,'text-cliking_red':activePages.length>=2}">{{activePages.length>=2? "Queue is full":activePages.length==1?"You can fetch one more":""}}</span> </span>
  <div *ngIf="activePages.length>0" class="mt-5">
    <div class="text-sm" *ngFor="let page of activePages" [ngClass]="{
      'text-facebook':page.source=='facebook',
      'text-instagram':page.source=='instagram',
      'text-google':page.source=='google',
      'text-linkedin':page.source=='linkedin'
      }">
      <div class="flex gap-3 items-center justify-center ">
        <span>{{page.source}}</span>
        <span>{{page.name}}</span>
        <span *ngIf="page.isDownloading">
          <svg xmlns="http://www.w3.org/2000/svg" width="18"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download"><path d="M12 15V3"/><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/></svg>
        </span>
        <span *ngIf="page.isSynching">
          <svg xmlns="http://www.w3.org/2000/svg" width="18"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-folder-sync-icon lucide-folder-sync"><path d="M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5"/><path d="M12 10v4h4"/><path d="m12 14 1.535-1.605a5 5 0 0 1 8 1.5"/><path d="M22 22v-4h-4"/><path d="m22 18-1.535 1.605a5 5 0 0 1-8-1.5"/></svg>
        </span>
         <span  class="ml-5 loading loading-spinner loading-xs"></span>
      </div>
    </div>
  </div>
  <div class="flex justify-between gap-2 mt-10">
    <app-group-pages [source]="'linkedin'" [group]="currentGroup" [activePages]="activePages" (processPagesEvent)="process($event)"/>
    <app-group-pages [source]="'google'" [group]="currentGroup"  [activePages]="activePages" (processPagesEvent)="process($event)"/>
    <app-group-pages [source]="'facebook'" [group]="currentGroup"  [activePages]="activePages" (processPagesEvent)="process($event)"/>
    <app-group-pages [source]="'instagram'" [group]="currentGroup"  [activePages]="activePages" (processPagesEvent)="process($event)"/>
  </div>
  </app-modal>
  <app-modal
		[isOpen]="isModalOpen"
		[heading]="'generic.successCreateGroup'"
		[icon]="modalIcon"
  ></app-modal>
</div>
